export default __webpack_public_path__ + "static/media/sport-ctg.0c518ec6.webp";